import classNames from 'classnames';
import { Portal, svgSprite } from '../../hybrid/wrappers';
import css from './TooltipModal.module.scss';

export default function TooltipModal(props) {
    const { closeHandler, text } = props;
    return (
        <Portal closeHandler={closeHandler}>
            <div className={css.modal}>
                <div onClick={closeHandler} className={classNames('circleButton', css.closeBtn)}>
                    {svgSprite('cross', { className: css.closeSvg })}
                </div>
                {/* <div className={css.head}>
                    <div className={css.headIcon}>{svgSprite('question-circle-fill')}</div>
                    <p className={css.title}>
                        <T textName='information' defaultStr='Информация' />
                    </p>
                </div> */}
                <div className={css.body}>
                    <p className={css.bodyText}>{text}</p>
                </div>
            </div>
        </Portal>
    );
}
